import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "roles",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "User Type", -1)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "99",
  selected: "",
  disabled: ""
}, "Please select", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "flex mt-4 space-x-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "Profile Information", -1)
const _hoisted_11 = { class: "flex flex-wrap mt-6 space-y-4 md:flex-nowrap md:space-x-4 md:space-y-0" }
const _hoisted_12 = { class: "w-full md:w-1/2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "First Name", -1)
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "w-full md:w-1/2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Last Name", -1)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "mt-6 space-y-4 md:space-y-4" }
const _hoisted_19 = { class: "w-full md:w-1/2" }
const _hoisted_20 = {
  for: "email-address",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "w-full md:w-1/2" }
const _hoisted_23 = {
  for: "mobile-number",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "mt-6 space-y-4 md:flex-nowrap md:space-y-4"
}
const _hoisted_26 = { class: "w-full md:w-1/2" }
const _hoisted_27 = {
  for: "email-address",
  class: "block mb-2 text-sm font-medium text-gray-900"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["value", "disabled"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, " Please note that when moving users between organisations, if this delegate has not been paid for, the admin of the new organisation will not be able to manage them as a delegate until the order they are attached to has been marked as paid. ", -1)
const _hoisted_31 = { class: "w-full md:w-1/2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  for: "email-address",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Organisation", -1)
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "job_roles",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Job Roles", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "email-address",
  class: "block mb-2 text-sm italic text-gray-900"
}, "Please enter each job on a new line.", -1)
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: "bio",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Bio", -1)
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 1,
  class: "mt-6 space-y-4 md:flex-nowrap md:space-y-4"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, "This user has access to paid resources", -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "External Platforms", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", null, "If an error occurs when creating an SSO or Moodle account, please check each platform for existing users with the same email address, then update here.", -1)
const _hoisted_47 = { class: "pt-6 space-y-4 md:space-y-4" }
const _hoisted_48 = { class: "flex items-center space-x-16" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  for: "mobile-number",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}, "Azure SSO ID:", -1)
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "flex items-center space-x-12" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", {
  for: "mobile-number",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}, "Moodle ID:", -1)
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_55 = { class: "flex items-center space-x-12" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  for: "mobile-number",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}, "Brevo ID:", -1)
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "flex mt-8 space-x-3" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_60 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "SSO Settings", -1)
const _hoisted_62 = { class: "mt-4" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Password", -1)
const _hoisted_64 = { class: "mt-4" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Block Access", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", null, "If you block a users SSO access they will no longer be able to access their portal. Should be toggled when a user account needs to be suspended.", -1)
const _hoisted_67 = { class: "pb-8 mt-6" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "Contact Address", -1)
const _hoisted_69 = { class: "flex flex-wrap mt-6 space-y-4 md:space-y-0 md:flex-nowrap md:space-x-4" }
const _hoisted_70 = { class: "w-full md:w-1/2" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", {
  for: "address_line_one",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Address Line 1", -1)
const _hoisted_72 = ["disabled"]
const _hoisted_73 = { class: "w-full md:w-1/2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", {
  for: "address_line_2",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Address Line 2", -1)
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { class: "flex flex-wrap mt-6 space-y-4 md:space-y-0 md:flex-nowrap md:space-x-4" }
const _hoisted_77 = { class: "w-full md:w-1/2" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "City", -1)
const _hoisted_79 = ["disabled"]
const _hoisted_80 = { class: "w-full md:w-1/2" }
const _hoisted_81 = ["for"]
const _hoisted_82 = ["disabled"]
const _hoisted_83 = ["disabled"]
const _hoisted_84 = { class: "flex flex-wrap mt-6 space-y-4 md:space-y-0 md:flex-nowrap md:space-x-4" }
const _hoisted_85 = { class: "w-full md:w-1/2" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", {
  for: "postcode",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Postcode/ZIP", -1)
const _hoisted_87 = ["disabled"]
const _hoisted_88 = { class: "w-full md:w-1/2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Country", -1)
const _hoisted_90 = ["disabled"]
const _hoisted_91 = ["value"]
const _hoisted_92 = { class: "flex mt-4 space-x-3" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_94 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "Facilitator Settings", -1)
const _hoisted_96 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", {
  for: "bio",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Set as Public", -1)
const _hoisted_98 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This profile will be viewable on the website as a "),
  /*#__PURE__*/_createElementVNode("strong", null, "Facilitator"),
  /*#__PURE__*/_createTextVNode(". If you do not want this to appear on the website please toggle this setting off.")
], -1)
const _hoisted_102 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_103 = {
  for: "programme_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_104 = ["disabled"]
const _hoisted_105 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_106 = {
  for: "programme_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_107 = {
  for: "programme_setting",
  class: "block mb-2 text-sm italic text-gray-900"
}
const _hoisted_108 = ["disabled"]
const _hoisted_109 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("label", {
  for: "bio",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Works With", -1)
const _hoisted_111 = { class: "space-y-2" }
const _hoisted_112 = { class: "space-x-2" }
const _hoisted_113 = ["value", "checked", "disabled"]
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_119 = {
  for: "other_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_120 = ["disabled"]
const _hoisted_121 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_122 = {
  for: "other_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_123 = ["disabled"]
const _hoisted_124 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_125 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("label", {
  for: "bio",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Can access Brick Clubs", -1)
const _hoisted_127 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_128 = ["disabled"]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("ul", { class: "mt-1 ml-6 list-disc" }, [
  /*#__PURE__*/_createElementVNode("li", null, "View and Manage Brick Clubs")
], -1)
const _hoisted_131 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", {
  for: "bio",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Can access SmartSurvey", -1)
const _hoisted_133 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_134 = ["disabled"]
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("ul", { class: "mt-1 ml-6 list-disc" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Complete Brick Club surveys"),
  /*#__PURE__*/_createElementVNode("li", null, "View Brick Club survey results and responses"),
  /*#__PURE__*/_createElementVNode("li", null, "Set and manage Brick Club participants' goals")
], -1)
const _hoisted_137 = { class: "flex mt-4 space-x-3" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_139 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_140 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "Trainer Settings", -1)
const _hoisted_141 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("label", {
  for: "bio",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Set as Public", -1)
const _hoisted_143 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_144 = ["disabled"]
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This profile will be viewable on the website as a "),
  /*#__PURE__*/_createElementVNode("strong", null, "Trainer"),
  /*#__PURE__*/_createTextVNode(". If you do not want this to appear on the website please toggle this setting off.")
], -1)
const _hoisted_147 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_148 = {
  for: "programme_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_149 = ["disabled"]
const _hoisted_150 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_151 = {
  for: "programme_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_152 = {
  for: "programme_setting",
  class: "block mb-2 text-sm italic text-gray-900"
}
const _hoisted_153 = ["disabled"]
const _hoisted_154 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("label", {
  for: "bio",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Can access SmartSurvey", -1)
const _hoisted_156 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_157 = ["disabled"]
const _hoisted_158 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("ul", { class: "mt-1 ml-6 list-disc" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Access to Training Feedback")
], -1)
const _hoisted_160 = { class: "flex mt-4 space-x-3" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_162 = { class: "mt-6" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)

import { PropType, ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";

import RoleGuard from "../RoleGuard.vue";
import ConfirmationModal from "../modals/ConfirmationModal.vue";
import DefaultButton from "../DefaultButton.vue";
import ToggleCheckbox from "../ToggleCheckbox.vue";

import api from "../../api/api";
import { Country, Organisation, User } from "../../types";
import { useGlobalStore, useUserStore } from "../../store";
import { getUsersHighestRole, userHasRole } from "../../utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetails',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
  organisations: {
    type: Array as PropType<Organisation[]>,
    required: true,
  },
  countries: {
    type: Array as PropType<Country[]>,
    required: true,
  },
  canDeleteUser: {
    type: Boolean,
    required: true,
  },
},
  emits: ["fetchUser"],
  setup(__props, { emit: emits }) {

const props = __props;

const userStore = useUserStore();
const globalStore = useGlobalStore();
const router = useRouter();
const { user_roles } = storeToRefs(globalStore);
const { user: currentUser, facilitatorRoles, trainerRoles } = storeToRefs(userStore);





const isEditingLocation = ref(false);
const isEditingProfile = ref(false);
const isEditingRole = ref(false);
const isCurrentUser = ref(false);
const isEditingBio = ref(false);
const isSaving = ref(false);
const isDeleteUserModalOpen = ref(false);
const canDeleteUserValue = ref(props.canDeleteUser);

const editUser = ref({} as User);
const selectedRole = ref(0);
const job_roles = ref("");

const worksWithOptions = [
  "Early Years setting (children under 4 years)",
  "School (children 4-11 years)",
  "Secondary School (children 11-16 years)",
  "Further Education (16+ years)",
  "Adult service (18+ years)",
  "Older adult service (65+ years)",
  "Specialist Educational provision",
  "State funded healthcare setting (e.g NHS)",
  "Private healthcare setting (e.g private therapy centre)",
  "other-1",
  "other-2",
];

const filteredRoles = computed(() => {
  return user_roles.value.filter(role => {
    const bannedRoles = ["trainer-organisation", "facilitator-organisation", "l4a-trainer", "l4a-trainee"];

    // If the user is in a Play Included Organisation, we don't want to show certain roles
    if (props.user.organisation && props.user.organisation.play_included_organisation && bannedRoles.includes(role.name)) {
      return false;
    }

    return true;
  });
});

function filterByRole(organisation: Organisation) {
  // If the user has a role that is not allowed in the organisation, we don't want to show the Organisation
  if (organisation.play_included_organisation && userHasRole(props.user.roles, ["trainer-organisation", "facilitator-organisation", "l4a-trainer", "l4a-trainee"])) {
    return false;
  }

  return true;
}

async function deleteUser() {
  try {
    const response = await api.users.deleteAllUserData(props.user.id);

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", "User deleted");
      return router.push({ name: "Users" });
    }
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error deleting User");
  } finally {
    isDeleteUserModalOpen.value = false;
  }
}

async function toggleUserAccess() {
  try {
    const response = (await api.users.toggleUserAccess(props.user.id)).data.user;
    editUser.value.enabled = response.enabled;

    if (response.enabled) {
      globalStore.toast("SUCCESS", "User account unlocked");
    }

    if (!response.enabled) {
      globalStore.toast("SUCCESS", "User account locked");
    }
  } catch (e) {
    console.log(e);
    globalStore.toast("ERROR", "Error updating User");
  }
}

function isOptionSelected(option: string) {
  if (editUser.value.programme_setting === null) {
    return false;
  }

  if (editUser.value.programme_setting.data.find(i => i === option)) {
    return true;
  }

  return false;
}

function cancelEdit() {
  isEditingProfile.value = false;
  isEditingLocation.value = false;
  isEditingRole.value = false;
  isEditingBio.value = false;
  editUser.value = Object.assign({}, props.user);
}

async function updateUser() {
  try {
    isSaving.value = true;

    const formattedJobRoles = job_roles.value.split(`\n`);

    if (editUser.value.last_name === "" || editUser.value.first_name === "") {
      globalStore.toast("ERROR", "First and Last name are required");
      return;
    }
    if (editUser.value.email === "") {
      globalStore.toast("ERROR", "Email is required");
      return;
    }

    const response = await api.users.updateUser(props.user.id, {
      ...editUser.value,
      job_role: {
        data: formattedJobRoles,
      },
      programme_setting: editUser.value.programme_setting,
    });

    emits("fetchUser");

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", "User updated");
    }
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error updating User");
  } finally {
    isEditingProfile.value = false;
    isSaving.value = false;
  }
}

async function updateUserRole() {
  try {
    isSaving.value = true;
    const response = await api.users.updateUserRole(props.user.id, selectedRole.value);

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", "User role updated");
    }
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error updating User's role");
  } finally {
    isEditingRole.value = false;
    isSaving.value = false;
  }
}

/** Password Reset */
async function sendPasswordReset() {
  try {
    const response = await api.users.sendPasswordReset(props.user.id);

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", "Reset Password email sent");
    }
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error sending Reset Password email");
  }
}

async function createServiceAccount(service: string) {
  try {
    const response = await api.users.addUserToService(service, props.user.id);

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", `${service} account created`);
    }

    window.location.reload();
  } catch (error) {
    console.log("ERROR", error);
    globalStore.toast("ERROR", `Error creating ${service} account`);
  }
}

editUser.value = Object.assign({}, props.user);

if (props.user.programme_setting === null) {
  editUser.value.programme_setting = {
    data: [],
    other: {
      field_1: "",
      field_2: "",
    },
  };
}

selectedRole.value = props.user.roles.length ? getUsersHighestRole(props.user.roles).id : 99;
job_roles.value = props.user.job_role.data.join("\n");

if (currentUser.value.id === props.user.id) {
  isCurrentUser.value = true;
}

watch(
  () => editUser.value.has_brick_club_access,
  newValue => {
    if (!newValue) {
      editUser.value.has_smartsurvey_access = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(userStore).userIsAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("select", {
              id: "subscription",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRole).value = $event)),
              disabled: !isEditingRole.value,
              class: "text-black border rounded w-full capitalize font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
            }, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredRoles), (role) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: role.id,
                  key: role.id,
                  class: "capitalize"
                }, _toDisplayString(_ctx.$t(role.name)), 9, _hoisted_6))
              }), 128))
            ], 8, _hoisted_4), [
              [_vModelSelect, selectedRole.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (!isCurrentUser.value && !isEditingRole.value)
              ? (_openBlock(), _createBlock(DefaultButton, {
                  key: 0,
                  type: "primary",
                  onAction: _cache[1] || (_cache[1] = ($event: any) => (isEditingRole.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Edit Membership ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (isEditingRole.value)
              ? (_openBlock(), _createBlock(DefaultButton, {
                  key: 1,
                  type: "primary",
                  onAction: updateUserRole,
                  loading: isSaving.value,
                  disabled: isSaving.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("save-changes")), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true),
            (isEditingRole.value)
              ? (_openBlock(), _createBlock(DefaultButton, {
                  key: 2,
                  type: "secondary",
                  onAction: cancelEdit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _hoisted_8
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "firstname",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editUser.value.first_name) = $event)),
              class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
              placeholder: "firstname",
              disabled: !isEditingProfile.value,
              required: ""
            }, null, 8, _hoisted_14), [
              [_vModelText, editUser.value.first_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "lastname",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editUser.value.last_name) = $event)),
              class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
              placeholder: "lastname",
              disabled: !isEditingProfile.value,
              required: ""
            }, null, 8, _hoisted_17), [
              [_vModelText, editUser.value.last_name]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("email-address")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "email-address",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editUser.value.email) = $event)),
              class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
              placeholder: "email",
              disabled: !isEditingProfile.value,
              required: ""
            }, null, 8, _hoisted_21), [
              [_vModelText, editUser.value.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("mobile-number")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "mobile-number",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editUser.value.mobile_number) = $event)),
              class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
              placeholder: "mobile no.",
              disabled: !isEditingProfile.value
            }, null, 8, _hoisted_24), [
              [_vModelText, editUser.value.mobile_number]
            ])
          ])
        ]),
        (_unref(userStore).userIsAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('trained-by')), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "subscription",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editUser.value.organisation_id) = $event)),
                  disabled: !isEditingProfile.value,
                  class: "text-black border rounded w-full capitalize focus:outline-none focus:shadow-outline-purple font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.organisations, (organisation) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: organisation.id,
                      key: organisation.id,
                      class: "capitalize",
                      disabled: !filterByRole(organisation)
                    }, _toDisplayString(organisation.name), 9, _hoisted_29))
                  }), 128))
                ], 8, _hoisted_28), [
                  [_vModelSelect, editUser.value.organisation_id]
                ]),
                _hoisted_30
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "sub-organisation",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editUser.value.sub_organisation) = $event)),
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  placeholder: "organisation",
                  disabled: !isEditingProfile.value
                }, null, 8, _hoisted_33), [
                  [_vModelText, editUser.value.sub_organisation]
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _hoisted_36,
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  id: "job_roles",
                  class: "block w-full h-24 py-2 text-gray-900 border border-gray-600 rounded",
                  disabled: !isEditingProfile.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((job_roles).value = $event))
                }, null, 8, _hoisted_37), [
                  [_vModelText, job_roles.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  id: "bio",
                  class: "block w-full h-48 py-2 text-gray-900 border border-gray-600 rounded",
                  disabled: !isEditingProfile.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editUser.value.bio) = $event))
                }, null, 8, _hoisted_40), [
                  [_vModelText, editUser.value.bio]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.user.show_paid_resources)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
          : _createCommentVNode("", true),
        _createVNode(RoleGuard, { roles: ['admin', 'users-admin'] }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", null, [
                    _hoisted_49,
                    (isEditingProfile.value && !__props.user.azure_oid)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "text",
                          id: "mobile-number",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editUser.value.azure_oid) = $event)),
                          class: "block h-10 py-2 text-gray-900 border border-gray-600 rounded",
                          placeholder: "SSO ID"
                        }, null, 512)), [
                          [_vModelText, editUser.value.azure_oid]
                        ])
                      : _createCommentVNode("", true),
                    (!isEditingProfile.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(__props.user.azure_oid ?? "No SSO ID"), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (!__props.user.azure_oid)
                    ? (_openBlock(), _createBlock(DefaultButton, {
                        key: 0,
                        type: "text",
                        onAction: _cache[11] || (_cache[11] = ($event: any) => (createServiceAccount('azure')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Create SSO Account")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", null, [
                    _hoisted_52,
                    (isEditingProfile.value && !__props.user.moodle_id)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "text",
                          id: "mobile-number",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editUser.value.moodle_id) = $event)),
                          class: "block h-10 py-2 text-gray-900 border border-gray-600 rounded",
                          placeholder: "Moodle ID"
                        }, null, 512)), [
                          [_vModelText, editUser.value.moodle_id]
                        ])
                      : _createCommentVNode("", true),
                    (!isEditingProfile.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(__props.user.moodle_id ?? "No Moodle ID"), 1))
                      : _createCommentVNode("", true),
                    (!__props.user.country)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_54, "Please select a country to create a Moodle account"))
                      : _createCommentVNode("", true)
                  ]),
                  (!__props.user.moodle_id && __props.user.country)
                    ? (_openBlock(), _createBlock(DefaultButton, {
                        key: 0,
                        type: "text",
                        onAction: _cache[13] || (_cache[13] = ($event: any) => (createServiceAccount('moodle')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Create Moodle Account")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", null, [
                    _hoisted_56,
                    (!isEditingProfile.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(__props.user.brevo_id ?? "No Brevo ID"), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (!__props.user.brevo_id)
                    ? (_openBlock(), _createBlock(DefaultButton, {
                        key: 0,
                        type: "text",
                        onAction: _cache[14] || (_cache[14] = ($event: any) => (createServiceAccount('brevo')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Create Brevo Account")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_58, [
        (!isCurrentUser.value && !isEditingProfile.value)
          ? (_openBlock(), _createBlock(DefaultButton, {
              key: 0,
              type: "primary",
              onAction: _cache[15] || (_cache[15] = ($event: any) => (isEditingProfile.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("edit-details")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isEditingProfile.value)
          ? (_openBlock(), _createBlock(DefaultButton, {
              key: 1,
              type: "primary",
              onAction: updateUser,
              loading: isSaving.value,
              disabled: isSaving.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("save-changes")), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true),
        (isEditingProfile.value)
          ? (_openBlock(), _createBlock(DefaultButton, {
              key: 2,
              type: "secondary",
              onAction: cancelEdit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_59
    ]),
    (_unref(userHasRole)(_unref(currentUser).roles, ['admin', 'users-admin', 'clubs-admin', 'courses-admin']))
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("div", _hoisted_62, [
            _hoisted_63,
            _createVNode(DefaultButton, {
              type: "primary",
              onAction: sendPasswordReset
            }, {
              default: _withCtx(() => [
                _createTextVNode("Reset Password")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _createVNode(ToggleCheckbox, {
              value: !__props.user.enabled,
              onToggle: toggleUserAccess
            }, null, 8, ["value"]),
            _hoisted_66
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_67, [
      _hoisted_68,
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "address_line_one",
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editUser.value.address_line_1) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "Buckingham Palace",
            disabled: !isEditingLocation.value,
            required: ""
          }, null, 8, _hoisted_72), [
            [_vModelText, editUser.value.address_line_1]
          ])
        ]),
        _createElementVNode("div", _hoisted_73, [
          _hoisted_74,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "address_line_2",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((editUser.value.address_line_2) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            disabled: !isEditingLocation.value,
            required: ""
          }, null, 8, _hoisted_75), [
            [_vModelText, editUser.value.address_line_2]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_76, [
        _createElementVNode("div", _hoisted_77, [
          _hoisted_78,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "city",
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((editUser.value.city) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "Westminster",
            disabled: !isEditingLocation.value,
            required: ""
          }, null, 8, _hoisted_79), [
            [_vModelText, editUser.value.city]
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("label", {
            for: __props.user.state ? 'state' : 'county',
            class: "block mb-2 text-sm font-medium text-gray-900"
          }, _toDisplayString(__props.user.state ? "State" : "County"), 9, _hoisted_81),
          (editUser.value.state)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "text",
                id: "state",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((editUser.value.state) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                placeholder: "New York",
                disabled: !isEditingLocation.value,
                required: ""
              }, null, 8, _hoisted_82)), [
                [_vModelText, editUser.value.state]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                id: "county",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((editUser.value.county) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                placeholder: "Central London",
                disabled: !isEditingLocation.value,
                required: ""
              }, null, 8, _hoisted_83)), [
                [_vModelText, editUser.value.county]
              ])
        ])
      ]),
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _hoisted_86,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "postcode",
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((editUser.value.postcode) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "SW1A 1AA",
            disabled: !isEditingLocation.value,
            required: ""
          }, null, 8, _hoisted_87), [
            [_vModelText, editUser.value.postcode]
          ])
        ]),
        _createElementVNode("div", _hoisted_88, [
          _hoisted_89,
          _withDirectives(_createElementVNode("select", {
            id: "subscription",
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((editUser.value.country) = $event)),
            disabled: !isEditingLocation.value,
            class: "text-black border rounded w-full capitalize font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.countries, (region) => {
              return (_openBlock(), _createElementBlock("option", {
                value: region.name,
                key: region.id,
                class: "capitalize"
              }, _toDisplayString(region.name), 9, _hoisted_91))
            }), 128))
          ], 8, _hoisted_90), [
            [_vModelSelect, editUser.value.country]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_92, [
        (!isCurrentUser.value && !isEditingLocation.value)
          ? (_openBlock(), _createBlock(DefaultButton, {
              key: 0,
              type: "primary",
              onAction: _cache[23] || (_cache[23] = ($event: any) => (isEditingLocation.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Edit Location ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isEditingLocation.value)
          ? (_openBlock(), _createBlock(DefaultButton, {
              key: 1,
              type: "primary",
              onAction: updateUser,
              loading: isSaving.value,
              disabled: isSaving.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("save-changes")), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true),
        (isEditingLocation.value)
          ? (_openBlock(), _createBlock(DefaultButton, {
              key: 2,
              type: "secondary",
              onAction: cancelEdit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_93
    ]),
    _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'users-admin'] }, {
      default: _withCtx(() => [
        (__props.user.roles.find(i => [..._unref(facilitatorRoles), 'facilitator-organisation'].includes(i.name)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
              _hoisted_95,
              _createElementVNode("div", _hoisted_96, [
                _hoisted_97,
                _createElementVNode("label", _hoisted_98, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((editUser.value.public) = $event)),
                    disabled: !isEditingBio.value,
                    class: "sr-only peer"
                  }, null, 8, _hoisted_99), [
                    [_vModelCheckbox, editUser.value.public]
                  ]),
                  _hoisted_100
                ]),
                _hoisted_101
              ]),
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.$t("directory-email-address")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((editUser.value.directory_email_address) = $event)),
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  disabled: !isEditingBio.value
                }, null, 8, _hoisted_104), [
                  [_vModelText, editUser.value.directory_email_address]
                ])
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.$t("directory-website")), 1),
                _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t("directory-website-helptext-2")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((editUser.value.directory_website) = $event)),
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  disabled: !isEditingBio.value
                }, null, 8, _hoisted_108), [
                  [_vModelText, editUser.value.directory_website]
                ])
              ]),
              _createElementVNode("div", _hoisted_109, [
                _hoisted_110,
                _createElementVNode("div", _hoisted_111, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(worksWithOptions, (option, index) => {
                    return _createElementVNode("div", { key: index }, [
                      _createElementVNode("label", _hoisted_112, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "p-2",
                          value: option,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((editUser.value.programme_setting.data) = $event)),
                          checked: isOptionSelected(option),
                          disabled: !isEditingBio.value
                        }, null, 8, _hoisted_113), [
                          [_vModelCheckbox, editUser.value.programme_setting.data]
                        ]),
                        (!['other-1', 'other-2'].includes(option))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(option), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_115, [
                              (option === 'other-1')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_116, "Community setting (please specifiy)"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_117, "A different setting not already covered (please specify)"))
                            ]))
                      ])
                    ])
                  }), 64)),
                  _createElementVNode("div", null, [
                    (isOptionSelected('other-1'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                          _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t("community-setting")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "other_setting",
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((editUser.value.programme_setting.other.field_1) = $event)),
                            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                            disabled: !isEditingBio.value,
                            placeholder: "Other setting"
                          }, null, 8, _hoisted_120), [
                            [_vModelText, editUser.value.programme_setting.other.field_1]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (isOptionSelected('other-2'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                          _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.$t("other-setting")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "other_setting",
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((editUser.value.programme_setting.other.field_2) = $event)),
                            disabled: !isEditingBio.value,
                            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                            placeholder: "Other setting"
                          }, null, 8, _hoisted_123), [
                            [_vModelText, editUser.value.programme_setting.other.field_2]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (
          __props.user.roles.find(i =>
            [..._unref(facilitatorRoles), 'facilitator-organisation', 'parent', 'brick-club-family', 'admin', 'users-admin', 'clubs-admin', 'users-admin'].includes(i.name)
          )
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
              _createElementVNode("div", _hoisted_125, [
                _hoisted_126,
                _createElementVNode("label", _hoisted_127, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((editUser.value.has_brick_club_access) = $event)),
                    disabled: !isEditingBio.value,
                    class: "sr-only peer"
                  }, null, 8, _hoisted_128), [
                    [_vModelCheckbox, editUser.value.has_brick_club_access]
                  ]),
                  _hoisted_129
                ]),
                _createElementVNode("p", null, _toDisplayString(__props.user.has_brick_club_access ? "This profile will lose access to the following:" : "This profile will have access to the following:"), 1),
                _hoisted_130
              ]),
              _createElementVNode("div", _hoisted_131, [
                _hoisted_132,
                _createElementVNode("label", _hoisted_133, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((editUser.value.has_smartsurvey_access) = $event)),
                    disabled: !isEditingBio.value || !editUser.value.has_brick_club_access,
                    class: "sr-only peer"
                  }, null, 8, _hoisted_134), [
                    [_vModelCheckbox, editUser.value.has_smartsurvey_access]
                  ]),
                  _hoisted_135
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("smart_survey_helptext")), 1),
                _createElementVNode("p", null, _toDisplayString(__props.user.has_smartsurvey_access ? "This profile will lose access to the following:" : "This profile will have access to the following:"), 1),
                _hoisted_136
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_137, [
            (!isEditingBio.value)
              ? (_openBlock(), _createBlock(DefaultButton, {
                  key: 0,
                  type: "primary",
                  onAction: _cache[32] || (_cache[32] = ($event: any) => (isEditingBio.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Edit Public Bio ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (isEditingBio.value)
              ? (_openBlock(), _createBlock(DefaultButton, {
                  key: 1,
                  type: "primary",
                  onAction: updateUser,
                  loading: isSaving.value,
                  disabled: isSaving.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("save-changes")), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true),
            (isEditingBio.value)
              ? (_openBlock(), _createBlock(DefaultButton, {
                  key: 2,
                  type: "secondary",
                  onAction: cancelEdit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _hoisted_138
        ]),
        (__props.user.roles.find(i => _unref(trainerRoles).includes(i.name)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
              _hoisted_140,
              _createElementVNode("div", _hoisted_141, [
                _hoisted_142,
                _createElementVNode("label", _hoisted_143, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((editUser.value.public) = $event)),
                    disabled: !isEditingBio.value,
                    class: "sr-only peer"
                  }, null, 8, _hoisted_144), [
                    [_vModelCheckbox, editUser.value.public]
                  ]),
                  _hoisted_145
                ]),
                _hoisted_146
              ]),
              _createElementVNode("div", _hoisted_147, [
                _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.$t("directory-email-address")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((editUser.value.directory_email_address) = $event)),
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  disabled: !isEditingBio.value
                }, null, 8, _hoisted_149), [
                  [_vModelText, editUser.value.directory_email_address]
                ])
              ]),
              _createElementVNode("div", _hoisted_150, [
                _createElementVNode("label", _hoisted_151, _toDisplayString(_ctx.$t("directory-website")), 1),
                _createElementVNode("label", _hoisted_152, _toDisplayString(_ctx.$t("directory-website-helptext-2")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((editUser.value.directory_website) = $event)),
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  disabled: !isEditingBio.value
                }, null, 8, _hoisted_153), [
                  [_vModelText, editUser.value.directory_website]
                ])
              ]),
              _createElementVNode("div", _hoisted_154, [
                _hoisted_155,
                _createElementVNode("label", _hoisted_156, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((editUser.value.has_smartsurvey_access) = $event)),
                    disabled: !isEditingBio.value,
                    class: "sr-only peer"
                  }, null, 8, _hoisted_157), [
                    [_vModelCheckbox, editUser.value.has_smartsurvey_access]
                  ]),
                  _hoisted_158
                ]),
                _createElementVNode("p", null, _toDisplayString(__props.user.has_smartsurvey_access ? "This profile will lose access to the following:" : "This profile will have access to the following:"), 1),
                _hoisted_159
              ]),
              _createElementVNode("div", _hoisted_160, [
                (!isCurrentUser.value && !isEditingBio.value)
                  ? (_openBlock(), _createBlock(DefaultButton, {
                      key: 0,
                      type: "primary",
                      onAction: _cache[37] || (_cache[37] = ($event: any) => (isEditingBio.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Edit Public Bio ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (isEditingBio.value)
                  ? (_openBlock(), _createBlock(DefaultButton, {
                      key: 1,
                      type: "primary",
                      onAction: updateUser,
                      loading: isSaving.value,
                      disabled: isSaving.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("save-changes")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"]))
                  : _createCommentVNode("", true),
                (isEditingBio.value)
                  ? (_openBlock(), _createBlock(DefaultButton, {
                      key: 2,
                      type: "secondary",
                      onAction: cancelEdit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_161
            ]))
          : _createCommentVNode("", true),
        _createVNode(RoleGuard, { roles: ['admin', 'users-admin'] }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_162, [
              _createVNode(DefaultButton, {
                type: "danger",
                class: _normalizeClass([!canDeleteUserValue.value ? 'cursor-not-allowed !border-gray-600 !bg-gray-600 !hover:bg-gray-600 !hover:border-gray-600' : '']),
                onAction: _cache[38] || (_cache[38] = ($event: any) => (isDeleteUserModalOpen.value = true)),
                disabled: !canDeleteUserValue.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("user-delete")), 1)
                ]),
                _: 1
              }, 8, ["class", "disabled"])
            ]),
            _hoisted_163
          ]),
          _: 1
        }),
        _createVNode(ConfirmationModal, {
          buttonText: "Delete User",
          class: "danger",
          isOpen: isDeleteUserModalOpen.value,
          onDelete: deleteUser,
          onClose: _cache[39] || (_cache[39] = ($event: any) => (isDeleteUserModalOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("user-delete-confirmation")), 1)
          ]),
          _: 1
        }, 8, ["isOpen"])
      ]),
      _: 1
    })
  ]))
}
}

})